import { createFileRoute } from "@tanstack/react-router"
import { getUseCaseBySlug } from "@/data/use-cases/use-cases-registry"
import { getUseCaseBySlugForLanguage } from "@/data/use-cases/use-cases-i18n"
import { useTranslation } from "@/lib/i18n"
import UseCasePageLayout from "@/components/use-cases/UseCasePageLayout"

const fallback = getUseCaseBySlug("instagram-comment-dm-automation")!

export const Route = createFileRoute("/$lang/use-case/instagram-comment-dm-automation")({
  component: LangAutoRespondPage,
})

function LangAutoRespondPage() {
  const { language } = useTranslation()
  const data = getUseCaseBySlugForLanguage(language, "instagram-comment-dm-automation") || fallback
  return <UseCasePageLayout data={data} />
}
